import { END_BEHAVIOR_DESTROY, END_BEHAVIOR_FORWARD, END_BEHAVIOR_FREEZE, END_BEHAVIOR_RESTART, } from '../constants';
/**
 * 结束行为
 */
export var EndBehavior;
(function (EndBehavior) {
    /**
     * 销毁
     */
    EndBehavior[EndBehavior["destroy"] = 0] = "destroy";
    /**
     * 重播
     */
    EndBehavior[EndBehavior["restart"] = 5] = "restart";
    /**
     * 无限播放
     */
    EndBehavior[EndBehavior["forward"] = 2] = "forward";
    /**
     * 冻结
     */
    EndBehavior[EndBehavior["freeze"] = 4] = "freeze";
})(EndBehavior || (EndBehavior = {}));
